module.exports = __webpack_public_path__ + "img/beautify3.99501054.webp";